function s(t) {
  var e = this.__data__, a = e.delete(t);
  return this.size = e.size, a;
}
export {
  s as default
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/~/.pnpm/lodash-es@4.17.21/~/lodash-es/_stackDelete.js
// module id = 1550
// module chunks = 67